import { render, staticRenderFns } from "./DepositDetailFooter.vue?vue&type=template&id=73772e2c&scoped=true&"
import script from "./DepositDetailFooter.vue?vue&type=script&lang=ts&"
export * from "./DepositDetailFooter.vue?vue&type=script&lang=ts&"
import style0 from "./DepositDetailFooter.vue?vue&type=style&index=0&id=73772e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73772e2c",
  null
  
)

export default component.exports